module.exports = __webpack_public_path__ + "officialStatic/img/qua-bg.50bcab2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/about/qua-bg.png
// module id = qh8n
// module chunks = 0